<ng-container *ngIf="spo">
  <button
    data-test="86XO1RjJ"
    *ngIf="spo.statusNote"
    class="icon"
    [ngClass]="{
      'text-red': isError(),
      'text-green': !isError()
    }"
    [mdHoverPopover]="tooltipTemplate"
    mdHoverPopoverPlacement="top"
  >
    <i data-test="U97gNjK1" class="material-icons">
      {{ isError() ? 'error_outline' : 'info_outline' }}
    </i>
  </button>
  <ng-template #tooltipTemplate>
    <div data-test="wA0vv9Xc">
      <div data-test="jJLYwZjr">
        <b data-test="_WNlmpF3">{{ statusTooltipCation[spo.status.toString()] }}</b>
      </div>
      {{ spo.statusNote }}
    </div>
  </ng-template>
</ng-container>
